/**
 * @generated SignedSource<<4aec76c93c04c49ac3678f7d7ddab1c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiscountTypeKindInput = "System" | "User";
export type DiscountActionsTable_QueryFragmentRefetch$variables = {
  after?: string | null;
  before?: string | null;
  filterByActionTitle?: string | null;
  filterByCode?: string | null;
  filterByDiscountTypeKind?: DiscountTypeKindInput | null;
  filterByIsArchived?: boolean | null;
  first?: number | null;
  last?: number | null;
};
export type DiscountActionsTable_QueryFragmentRefetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"discountActionsTable_QueryFragment">;
};
export type DiscountActionsTable_QueryFragmentRefetch = {
  response: DiscountActionsTable_QueryFragmentRefetch$data;
  variables: DiscountActionsTable_QueryFragmentRefetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "before"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByActionTitle"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByDiscountTypeKind"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByIsArchived"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "last"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "filterByActionTitle",
    "variableName": "filterByActionTitle"
  },
  {
    "kind": "Variable",
    "name": "filterByCode",
    "variableName": "filterByCode"
  },
  {
    "kind": "Variable",
    "name": "filterByDiscountTypeKind",
    "variableName": "filterByDiscountTypeKind"
  },
  {
    "kind": "Variable",
    "name": "filterByIsArchived",
    "variableName": "filterByIsArchived"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscountActionsTable_QueryFragmentRefetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "discountActionsTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscountActionsTable_QueryFragmentRefetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "DiscountActionsConnection",
                "kind": "LinkedField",
                "name": "DiscountActions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DiscountActionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DiscountAction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "percent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isReductible",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "discountType",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "kind",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "filterByDiscountTypeKind",
                  "filterByActionTitle",
                  "filterByCode",
                  "filterByIsArchived"
                ],
                "handle": "connection",
                "key": "DiscountActionsTable_DiscountActions",
                "kind": "LinkedHandle",
                "name": "DiscountActions"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a503ce5678ee2ebce8d46710ecf8f521",
    "id": null,
    "metadata": {},
    "name": "DiscountActionsTable_QueryFragmentRefetch",
    "operationKind": "query",
    "text": "query DiscountActionsTable_QueryFragmentRefetch(\n  $after: String = null\n  $before: String = null\n  $filterByActionTitle: String\n  $filterByCode: String\n  $filterByDiscountTypeKind: DiscountTypeKindInput\n  $filterByIsArchived: Boolean\n  $first: Int\n  $last: Int\n) {\n  ...discountActionsTable_QueryFragment_2t73B7\n}\n\nfragment discountActionsTable_DiscountActionFragment on DiscountAction {\n  id\n  title\n  percent\n  isReductible\n  discountType {\n    __typename\n    kind\n  }\n}\n\nfragment discountActionsTable_QueryFragment_2t73B7 on Query {\n  Admin {\n    Billing {\n      DiscountActions(after: $after, before: $before, first: $first, last: $last, filterByDiscountTypeKind: $filterByDiscountTypeKind, filterByActionTitle: $filterByActionTitle, filterByCode: $filterByCode, filterByIsArchived: $filterByIsArchived) {\n        pageInfo {\n          startCursor\n          endCursor\n          hasNextPage\n          hasPreviousPage\n        }\n        edges {\n          cursor\n          node {\n            ...discountActionsTable_DiscountActionFragment\n            id\n            __typename\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "84659b00ab1de4465133325bdeb6b5c4";

export default node;
